import { show } from '@intercom/messenger-js-sdk';

export const useSupportChat = () => {
  const openSupportChat = () => {
    show();
  };

  return {
    openSupportChat,
  };
};
